var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLobbyEnter = function SvgLobbyEnter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lobby_enter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.475 0H7.525A7.525 7.525 0 0 0 0 7.525v12.95A7.525 7.525 0 0 0 7.525 28h12.95A7.525 7.525 0 0 0 28 20.475V7.525A7.525 7.525 0 0 0 20.475 0Z",
    fill: "#6D96FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.36 7.175h-3.068a1.17 1.17 0 0 0-1.167 1.167 1.17 1.17 0 0 0 1.167 1.166h3.068a.48.48 0 0 1 .478.479v8.038a.48.48 0 0 1-.478.478h-3.068a1.17 1.17 0 0 0-1.167 1.167 1.17 1.17 0 0 0 1.167 1.167h3.068a2.813 2.813 0 0 0 2.812-2.812V9.987a2.813 2.813 0 0 0-2.812-2.812Z",
    fill: "#CAD8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.618 14.828a1.162 1.162 0 0 0 0-1.645l-2.461-2.461a1.162 1.162 0 0 0-1.645 0 1.162 1.162 0 0 0 0 1.645l.466.466H7.805A1.17 1.17 0 0 0 6.638 14a1.17 1.17 0 0 0 1.167 1.167h3.173l-.466.466a1.162 1.162 0 0 0 .828 1.984c.303 0 .595-.117.828-.339l2.462-2.461-.012.011Z",
    fill: "#CAD8FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lobby_enter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgLobbyEnter;